import { ViewProps } from 'app-studio';
import { Size, Variant, Position, Alignment } from './DropdownMenu.type';
// Defines various size configurations (sm, md, lg) for dropdown menu items, specifying padding, font size, and minimum width.
export const DropdownMenuSizes: Record<Size, ViewProps> = {
  sm: {
    padding: '6px 8px',
    fontSize: '14px',
    minWidth: '160px',
  },
  md: {
    padding: '8px 12px',
    fontSize: '16px',
    minWidth: '180px',
  },
  lg: {
    padding: '10px 16px',
    fontSize: '18px',
    minWidth: '200px',
  },
};
// Specifies different visual variants (default, filled, outline) for the dropdown menu, controlling background color, text color, and border styles.
export const DropdownMenuVariants: Record<Variant, ViewProps> = {
  default: {
    backgroundColor: 'color-white',
    color: 'color-gray-800',
  },
  filled: {
    backgroundColor: 'color-gray-100',
    color: 'color-gray-800',
  },
  outline: {
    backgroundColor: 'color-white',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'color-gray-200',
    color: 'color-gray-800',
  },
};
// Defines styles for interactive states (hover, active, disabled) of dropdown menu items, providing visual feedback.
export const DropdownMenuItemStates = {
  hover: {
    backgroundColor: 'color-gray-100',
  },
  active: {
    backgroundColor: 'color-gray-200',
  },
  disabled: {
    opacity: 0.5,
    cursor: 'not-allowed',
  },
};
// A utility function that calculates and returns the CSS properties required to position the dropdown menu based on the specified `side` (e.g., top, bottom) and `align` (e.g., start, center).
export const getDropdownPosition = (
  side: Position = 'bottom',
  align: Alignment = 'start'
): ViewProps => {
  const positions: Record<Position, ViewProps> = {
    top: {
      bottom: '100%',
      marginBottom: '8px',
      ...(align === 'start' && { left: 0 }),
      ...(align === 'center' && { left: '50%', transform: 'translateX(-50%)' }),
      ...(align === 'end' && { right: 0 }),
    },
    right: {
      left: '100%',
      marginLeft: '8px',
      ...(align === 'start' && { top: 0 }),
      ...(align === 'center' && { top: '50%', transform: 'translateY(-50%)' }),
      ...(align === 'end' && { bottom: 0 }),
    },
    bottom: {
      top: '100%',
      marginTop: '8px',
      ...(align === 'start' && { left: 0 }),
      ...(align === 'center' && { left: '50%', transform: 'translateX(-50%)' }),
      ...(align === 'end' && { right: 0 }),
    },
    left: {
      right: '100%',
      marginRight: '8px',
      ...(align === 'start' && { top: 0 }),
      ...(align === 'center' && { top: '50%', transform: 'translateY(-50%)' }),
      ...(align === 'end' && { bottom: 0 }),
    },
  };
  return positions[side];
};
